import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from '../../environment/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  baseurl = environment.api_client_service;

  constructor(private http: HttpClient) { }

  send_login_code(email: string): Observable<any> {
    const body = {email};
    return this.http.post(this.baseurl + '/client/auth/request-otp', body);
  }

  send_verification_code(email: string, token: string) {
    const body = {email};
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    });
    return this.http.post(this.baseurl + '/client/authorizat-form/email/generate-otp', body, {headers});
  }

  verify_email_in_auth_form(email: string, code: string, token: string) {
    const body = {email, code};
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    });
    return this.http.post(this.baseurl + '/client/authorizat-form/email/verify', body, {headers});
  }

  auth_login(email: string, code: string): Observable<any> {
    const body= {
      "email": email,
      "code": code
    }
    return this.http.post(this.baseurl + '/client/auth/login', body);
  }

  login_by_token(token: string): Observable<any> {
    const payload = {
      token
    };
    return this.http.post(this.baseurl + '/client/auth/login-by-time-login-reference', payload);
  }

  auth_logout(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    });
    return this.http.post(this.baseurl + '/client/auth/logout', {}, {headers});
  }
}
